/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
require('@fancyapps/fancybox');

const VimeoPlayer = require('@vimeo/player');

// window.Headroom = require('headroom.js');
// import 'headroom.js/dist/jQuery.headroom'

import { Foundation } from './foundation';
import { WOW } from 'wowjs';
Foundation.addToJquery(jQuery);


/**
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 *
 * Application script
 *
 */
$(function() {
    $(document).foundation();

    // Image tile accordions
    // $('.image-tile--accordion').off('click');

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.image-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.image-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.image-tile__content').slideToggle();
        });
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.icon-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.icon-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.icon-tile__content').slideToggle();
        });
    }

    // Load Google map javascript
    if(document.querySelector('[data-maps-api-key]') && !document.querySelector('.gMapsAPI')){
        if($('[data-maps-api-key]').length){
            let script = document.createElement('script');
            const apiKey = $('[data-maps-api-key]:first').attr('data-maps-api-key');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initializeMaps';
            script.className = 'gMapsAPI';
            document.body.appendChild(script);
        }
    }

    // Banner Slideshow
    if($('.banner--slick').length > 0) {
        $('.banner--slick').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            fade: true,
        });
    }

    // Gallery Slideshow
    if($('.gallery-slideshow__inner').length > 0) {
        var $status = $('.gallery-slideshow__pagination'),
            $slickElement = $('.gallery-slideshow__inner'),
            totalSlides,
            slidePosition,
            $currentImage = $('.gallery-slideshow .slick-current img');


        /*

        This doesn't appear to be working

        $('.gallery-slideshow__slide').each(function() {
            var currentImage = $(this).children('.gallery-slideshow__image'),
                imageWidth = $(currentImage).width(),
                imageText = $(this).children('.gallery-slideshow__text');
            $(imageText).width(imageWidth);
            console.log(imageWidth);
        });
        */

        $slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            speed: 800,
            lazyload: 'ondemand'
        });
    };


    // Gallery Carousel
    $('.gallery-carousel__slides').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: true,
        prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
        nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
        asNavFor: '.gallery-carousel__thumbs'
    });

    $('.gallery-carousel__thumbs').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.gallery-carousel__slides',
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        centerPadding: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       true,             // trigger animations on mobile devices (default is true)
            live:         true,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    wow.init();

    // Match height
    $('.mh').matchHeight({
        byRow: true
    });

    // Headroom - sticky header when scrolling upwards
    // if (Foundation.MediaQuery.is('small only')) {
    //     var header = $("#header"),
    //         headerHeight = header.height();
    //
    //     $(header).headroom(
    //     {
    //         offset : headerHeight,
    //         onTop: function() {
    //             $(header).removeClass('headroom--transition');
    //         },
    //         onNotTop: function() {
    //             setTimeout(function() {
    //                 $(header).addClass('headroom--transition');
    //             }, 250);
    //         }
    //     });
    // }

    /* Profiles */
        $('body').on('click', '.profile-btn', function(e){
            var parent = $(this).closest('.person');

            // Check the parent and open or close as needed
            if(parent.hasClass('is-open')){
                $('.person').removeClass('is-open');
            } else {
                $('.person').removeClass('is-open');
                parent.addClass('is-open');
            }
        });

});



// WEBPACK FOOTER //
// ./themes/base/js/app.js